import * as tslib_1 from "tslib";
import ComposeBody from './ComposeBody';
import ComposeBottom from './ComposeBottom';
import ComposeTop from './ComposeTop';
import { observer } from 'mobx-react';
import { lazyUpdateRibbonWidth } from 'owa-editor-ribbonplugin';
import { keydownHandler } from 'owa-hotkeys';
import { addInitialAction } from 'owa-initial-actions';
import { createMailComposeAdapter, runAfterNotificationSetup } from 'owa-mail-addins';
import { lazyHasInlineImage } from 'owa-mail-addins';
import clearAttachmentFilesToUpload from 'owa-mail-compose-store/lib/actions/clearAttachmentFilesToUpload';
import discardCompose from 'owa-mail-compose-store/lib/actions/discardCompose';
import trySaveMessage, { isSaving } from 'owa-mail-compose-store/lib/actions/trySaveMessage';
import trySendMessage from 'owa-mail-compose-store/lib/actions/trySendMessage';
import addAttachments from 'owa-mail-compose-store/lib/utils/addAttachments';
import { isViewStateDirty } from 'owa-mail-compose-store/lib/utils/viewStateUtils';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { resetFocus } from 'owa-mail-focus-manager';
import { getCommands } from 'owa-mail-hotkeys';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import { registerComposeFocusManager, unregisterComposeFocusManager, } from '../utils/composeFocusManager';
import { findComposePlugins, } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import getAutoFocusControl from 'owa-mail-compose-store/lib/utils/getAutoFocusControl';
import { lazyInitializeAddinsForItem, lazyDeinitializeAddinsForItem, lazyCloseTaskPaneAddinCommand, getComposeHostItemIndex, } from 'owa-addins-core';
var styles = require('./Compose.scss');
var classNames = require('classnames');
var AUTO_SAVE_INTERVAL = 30000;
var ALL_PADDINGS_FOR_EDITOR = 50;
var Compose = /** @class */ (function (_super) {
    tslib_1.__extends(Compose, _super);
    function Compose(props) {
        var _this = _super.call(this, props) || this;
        _this.setStickyBottomBorder = function (ref) {
            var stickyDockingPlugin = _this.plugins
                ? _this.plugins.dockingPlugin
                : null;
            if (_this.props.viewState.docking.useStickyDocking && stickyDockingPlugin) {
                stickyDockingPlugin.setStickyBottomBorder(ref);
            }
        };
        _this.rootDivRefCallback = function (div) {
            if (_this.plugins.dockingPlugin) {
                _this.plugins.dockingPlugin.setInitialVisiblePart(div);
            }
            _this.rootDiv = div;
        };
        _this.autoSaveDraft = function () {
            var viewState = _this.props.viewState;
            _this.plugins.contentOperationPlugin.updateContentToViewState();
            // Don't auto save if item creation is in progress
            if (!isSaving(viewState) && isViewStateDirty(viewState)) {
                trySaveMessage(viewState, true /*isAutoSave*/);
            }
        };
        _this.onResize = function () {
            _this.cancelResizeTimer();
            _this.resizeTimer = window.setTimeout(function () {
                _this.resizeTimer = 0;
                if (_this.rootDiv) {
                    var clientWidth = _this.rootDiv.clientWidth;
                    lazyUpdateRibbonWidth.importAndExecute(_this.props.viewState.ribbon, clientWidth);
                    if (isBrowserEdge() && _this.body) {
                        _this.body.setWidth(clientWidth - ALL_PADDINGS_FOR_EDITOR);
                    }
                }
                if (_this.bottom) {
                    _this.bottom.resize();
                }
            }, 1);
        };
        var viewState = _this.props.viewState;
        _this.adapter = createMailComposeAdapter(viewState);
        _this.plugins = findComposePlugins(viewState);
        return _this;
    }
    Compose.prototype.componentDidMount = function () {
        var _this = this;
        this.autoSaveDraftTimer = window.setInterval(this.autoSaveDraft, AUTO_SAVE_INTERVAL);
        registerComposeFocusManager(this);
        lazySubscribeToResizeEvent.importAndExecute(this.onResize, this.rootDiv.ownerDocument.defaultView.name, this.rootDiv.ownerDocument.defaultView);
        addInitialAction(this.props.initialActions, function () {
            _this.onResize();
        });
        this.focus();
        if (isMailFeatureEnabled('rp-addins')) {
            lazyCloseTaskPaneAddinCommand.import().then(function (closeTaskPaneAddinCommand) {
                closeTaskPaneAddinCommand();
            });
            lazyInitializeAddinsForItem.import().then(function (initializeAddinsForItem) {
                initializeAddinsForItem(getComposeHostItemIndex(_this.props.viewState.composeId), _this.adapter);
            });
        }
        runAfterNotificationSetup(function () {
            var viewState = _this.props.viewState;
            addAttachments(viewState, viewState.attachmentFilesToUpload).then(function () {
                if (isMailFeatureEnabled('rp-addins')) {
                    lazyHasInlineImage
                        .import()
                        .then(function (hasInlineImage) {
                        if (_this.plugins.addinPlugin &&
                            hasInlineImage(viewState.attachmentFilesToUpload)) {
                            // TODO: VSO 26855: addinPluggin is not guaranteed to have been initialized
                            _this.plugins.addinPlugin.triggerContentChangedByAddinEvent();
                        }
                    })
                        .then(function () {
                        clearAttachmentFilesToUpload(viewState);
                    });
                }
            });
        });
    };
    Compose.prototype.componentWillUnmount = function () {
        var _this = this;
        this.cancelResizeTimer();
        unregisterComposeFocusManager(this);
        window.clearInterval(this.autoSaveDraftTimer);
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.onResize, this.rootDiv.ownerDocument.defaultView.name);
        resetFocus();
        isMailFeatureEnabled('rp-addins') &&
            lazyDeinitializeAddinsForItem.import().then(function (deinitializeAddinsForItem) {
                deinitializeAddinsForItem(getComposeHostItemIndex(_this.props.viewState.composeId));
            });
    };
    Compose.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, viewState = _a.viewState;
        return (React.createElement("div", { className: classNames(className, styles.composeContainer), ref: this.rootDivRefCallback },
            React.createElement(ComposeTop, tslib_1.__assign({}, this.props, { plugins: this.plugins, ref: function (ref) { return (_this.top = ref); } })),
            React.createElement("div", null,
                React.createElement(ComposeBody, tslib_1.__assign({}, this.props, { plugins: this.plugins, ref: function (ref) { return (_this.body = ref); } })),
                React.createElement("div", null),
                React.createElement(ComposeBottom, tslib_1.__assign({ ref: function (ref) { return (_this.bottom = ref); }, isHidden: viewState.docking.isBottomDocking }, this.props, { plugins: this.plugins })),
                React.createElement("div", { className: styles.bottomBorder, ref: this.setStickyBottomBorder })),
            this.props.children));
    };
    /**
     * Callback when the compose pane gains focus from focus manager
     */
    Compose.prototype.focus = function () {
        var _this = this;
        if (!this.setFocusTimer) {
            // Always do focus in async mode because this function can be called from an action,
            // and at that time the component may not be updated by React yet.
            this.setFocusTimer = window.requestAnimationFrame(function () {
                if (_this.body && _this.top) {
                    var controlToFocus = getAutoFocusControl(_this.props.viewState);
                    if (controlToFocus == 7 /* Editor */) {
                        _this.body.trySetFocus();
                    }
                    else {
                        _this.top.trySetFocus(controlToFocus);
                    }
                }
                _this.setFocusTimer = 0;
            });
        }
    };
    Compose.prototype.getRootDiv = function () {
        return this.rootDiv;
    };
    Compose.prototype.cancelResizeTimer = function () {
        if (this.resizeTimer) {
            window.clearTimeout(this.resizeTimer);
            this.resizeTimer = 0;
        }
    };
    Compose.prototype.saveDraft = function () {
        this.plugins.contentOperationPlugin.updateContentToViewState();
        trySaveMessage(this.props.viewState);
    };
    Compose.prototype.sendMessage = function () {
        this.plugins.contentOperationPlugin.updateContentToViewState();
        trySendMessage(this.props.viewState);
    };
    Compose.prototype.discardDraft = function () {
        discardCompose(this.props.viewState);
    };
    tslib_1.__decorate([
        keydownHandler(getCommands().saveDraft)
    ], Compose.prototype, "saveDraft", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().sendMail)
    ], Compose.prototype, "sendMessage", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().discardDraft, true /*stopPropagation*/, true /*preventDefault*/, true /*allowHotkeyOnTextFields*/)
    ], Compose.prototype, "discardDraft", null);
    Compose = tslib_1.__decorate([
        observer
    ], Compose);
    return Compose;
}(React.Component));
export default Compose;
//# sourceMappingURL=Compose.js.map